
import React from "react";
import {
  Box,
  Grid,
  Typography,
  Paper,
  IconButton,
  CardContent,
} from "@mui/material";
import {
  Phone,
  Email,
  Facebook,
  Twitter,
  Instagram,
  LinkedIn,Telegram,
} from "@mui/icons-material";
import Footer from "../../Common/Footer";
import { styled } from "@mui/material/styles";

const PackageContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(5),
  color: "#fff",
  backgroundColor: "#006D77",
  borderRadius: "16px",
}));

const socialLinks = [
  { icon: <Facebook />, url: "https://www.facebook.com/ayuja.life" },
  { icon: <Twitter />, url: "https://x.com/ayuja_life" },
  { icon: <Instagram />, url: "https://www.instagram.com/ayuja.life" },
  { icon: <LinkedIn />, url: "https://www.linkedin.com/in/ayuja-lifecare-8a0892369/" },
  { icon: <Telegram />, url: "https://t.me/ayuja_life" },
  
];

const ContactUs = () => {
  return (
    <>
    <Paper
      elevation={3}
      sx={{
        minHeight: "60vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grid container justifyContent="center">
        <Grid item xs={12} md={8} lg={6}>
          <PackageContent>
            <CardContent sx={{ p: 0, width: "100%" }}>
              <Box sx={{ textAlign: "center" }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                  Contact Information
                </Typography>
                <Typography variant="body1" sx={{ mb: 3, opacity: 0.9 }}>
                  For emergency support or care requests, <br/>
                  please use the app or
                  dial our 24x7 helpline.
                </Typography>

                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 2 }}>
                  <Phone sx={{ mr: 1 }} />
                  <Typography variant="body1">+91-7661889977</Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 3 }}>
                  <Email sx={{ mr: 1 }} />
                  <Typography variant="body1">support@ayuja.life</Typography>
                </Box>

                {/* Social Icons */}
                <Box sx={{ display: "flex", gap: 2, justifyContent: "center", mt: 2 }}>
                  {socialLinks.map((social, idx) => (
                    <IconButton
                      key={idx}
                      color="inherit"
                      sx={{
                        transition: "transform 0.2s",
                        "&:active": { transform: "scale(1.3)" },
                        color: "#fff",
                      }}
                      onClick={() => window.open(social.url, "_blank")}
                    >
                      {social.icon}
                    </IconButton>
                  ))}
                </Box>
              </Box>
            </CardContent>
          </PackageContent>
        </Grid>
      </Grid>
   
    </Paper>
       <Footer />
       </>
  );
};

export default ContactUs;
